import Vue from 'vue'
import * as jsonpatch from 'fast-json-patch/index.mjs'

const taxableProperty = {
  state: {
    taxableProperties: [],
    selectedTaxableProperty: {},
    selectedTaxablePropertyOriginal: {},
    saving: false,
    searchCount: 0,
  },

  getters: {
    taxableProperties(state) {
      return state.taxableProperties
    },
    selectedTaxableProperty(state) {
      return state.selectedTaxableProperty
    },
    selectedTaxablePropertyOriginal(state) {
      return state.selectedTaxablePropertyOriginal
    },
    loading(state) {
      return state.searchCount > 0
    },
  },

  mutations: {
    taxableProperties(state, payload) {
      state.taxableProperties = payload
    },
    selectedTaxableProperty(state, payload) {
      state.selectedTaxableProperty = JSON.parse(JSON.stringify(payload))
    },
    selectedTaxablePropertyOriginal(state, payload) {
      state.selectedTaxablePropertyOriginal = JSON.parse(
        JSON.stringify(payload)
      )
    },
    saving(state, payload) {
      state.saving = payload
    },
    searchCount(state, payload) {
      state.searchCount = payload
    },
    increaseSearchCount(state, payload) {
      state.searchCount = state.searchCount + 1
    },
    decreaseSearchCount(state, payload) {
      state.searchCount = state.searchCount - 1
    },
  },

  actions: {
    setSelectedTaxableProperty(context, payload) {
      context.commit('selectedTaxableProperty', payload)
    },
    async loadTaxableProperties(context, payload) {
      const url = 'TaxableProperty'
      try {
        let res = await Vue.prototype.$axios.get(url)
        context.commit('taxableProperties', res.data)
        return res
      } catch (err) {
        console.error(err)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    refreshSelectedTaxableProperty(context, payload) {
      if (
        context.state.selectedTaxableProperty &&
        context.state.selectedTaxableProperty.Id > 0
      ) {
        context.dispatch(
          'loadSelectedTaxableProperty',
          context.state.selectedTaxableProperty.Id
        )
      }
    },
    async loadSelectedTaxableProperty(context, payload) {
      if (
        context.state.selectedTaxableProperty &&
        context.state.selectedTaxableProperty.Id != payload
      ) {
        context.commit('selectedTaxableProperty', {})
      }
      const url = 'TaxableProperty/' + payload
      context.commit('increaseSearchCount')
      try {
        let res = await Vue.prototype.$axios.get(url)
        context.commit('selectedTaxableProperty', res.data)
        context.commit('selectedTaxablePropertyOriginal', res.data)
        context.commit('decreaseSearchCount')
        return res
      } catch (err) {
        console.error(err)
        context.commit('decreaseSearchCount')
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    clearLookupCacheAndReloadTaxableProperties(context, payload) {
      caches.delete('apilookup-cache').finally(() => {
        context.dispatch('loadTaxableProperties')
      })
    },
    async createTaxableProperty(context, payload) {
      const url = `TaxableProperty`
      context.commit('saving', true)
      try {
        let res = await Vue.prototype.$axios.post(url, payload)
        context.dispatch(
          'messages/toastMessage',
          { color: 'success', message: 'taxable property created' },
          { root: true }
        )
        //if you will always need to reload the list after an item is created
        //you can uncomment out the following dispatch line.
        //Alternatively you can reload whatever object you need
        //when the promise resolves in the component that called it.
        //context.dispatch('loadTaxableProperties')
        context.commit('saving', false)
        return res
      } catch (err) {
        console.error(err)
        context.commit('saving', false)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    async patchTaxableProperty(context, payload) {
      var item = context.state.selectedTaxableProperty
      if (
        payload.Id &&
        payload.Id == context.state.selectedTaxablePropertyOriginal.Id
      ) {
        item = payload
      }
      var patchPayload = {}
      if (!payload.patchDoc || !payload.Id) {
        let original = context.state.selectedTaxablePropertyOriginal
        let current = item
        patchPayload.Id = item.Id
        var diff = jsonpatch.compare(original, current)
        patchPayload.patchDoc = diff
      } else {
        patchPayload = payload
      }
      if (patchPayload.patchDoc.length > 0) {
        const url = `TaxableProperty/${patchPayload.Id}`
        context.commit('saving', true)
        try {
          let res = await Vue.prototype.$axios.patch(url, patchPayload.patchDoc)
          context.dispatch(
            'messages/toastMessage',
            { color: 'success', message: 'taxable property updated' },
            { root: true }
          )
          //if you will always need to reload the list after an update
          //you can uncomment out the following dispatch line.
          //Alternatively you can reload whatever object you need
          //when the promise resolves in the component that called it.
          //context.dispatch('loadTaxableProperties')
          context.commit('saving', false)
          return res
        } catch (err) {
          console.error(err)
          context.commit('saving', false)
          context.dispatch('errors/handleError', err, { root: true })
          throw err
        }
      } else {
        return 'no changes'
      }
    },
    async updateTaxableProperty(context, payload) {
      const url = `TaxableProperty/${payload.Id}`
      context.commit('saving', true)
      try {
        let res = await Vue.prototype.$axios.put(url, payload)
        context.dispatch(
          'messages/toastMessage',
          { color: 'success', message: 'taxable property updated' },
          { root: true }
        )
        //if you will always need to reload the list after an update
        //you can uncomment out the following dispatch line.
        //Alternatively you can reload whatever object you need
        //when the promise resolves in the component that called it.
        //context.dispatch('loadTaxableProperties')
        context.commit('saving', false)
        return res
      } catch (err) {
        console.error(err)
        context.commit('saving', false)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    async saveTaxableProperty(context, payload) {
      if (payload.Id > 0) {
        return context.dispatch('updateTaxableProperty', payload)
      } else {
        return context.dispatch('createTaxableProperty', payload)
      }
    },
    async deleteTaxableProperty(context, payload) {
      const url = `TaxableProperty/${payload.Id}`
      try {
        let res = await Vue.prototype.$axios.delete(url)
        context.dispatch(
          'messages/toastMessage',
          { color: 'success', message: 'taxable property deleted' },
          { root: true }
        )
        //if you will always need to reload the list after a delete
        //you can uncomment out the following dispatch line.
        //Alternatively you can reload whatever object you need
        //when the promise resolves in the component that called it.
        //context.dispatch('loadTaxableProperties')
        return res
      } catch (err) {
        console.error(err)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
  },
}

export default taxableProperty
